var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-2 text-truncate",staticStyle:{"border-radius":"4px"},attrs:{"color":'disabled darken-' + _vm.typeId,"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm.typeName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }